module.exports = __webpack_public_path__ + "static/media/uploading.34db21a3.svg";